import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../../services/api';
import { FiBriefcase, FiMail, FiArrowLeft } from 'react-icons/fi';
import toast from 'react-hot-toast';
import './Auth.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) { toast.error('Please enter your email'); return; }
    setLoading(true);
    try {
      await authAPI.forgotPassword({ email });
      setSent(true);
      toast.success('Reset link sent to your email');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to send reset link');
    }
    setLoading(false);
  };

  return (
    <div className="auth-page">
      <div className="auth-card animate-fade-in">
        <div className="auth-header">
          <Link to="/" className="auth-brand"><FiBriefcase /> PlacementHunter</Link>
          <h2>Reset Password</h2>
          <p>{sent ? 'Check your email for a reset link' : 'Enter your email to receive a password reset link'}</p>
        </div>

        {!sent ? (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Email Address</label>
              <div className="input-icon-wrapper">
                <FiMail className="input-icon" />
                <input type="email" placeholder="you@example.com" value={email} onChange={(e) => setEmail(e.target.value)} />
              </div>
            </div>
            <button type="submit" className="btn btn-primary btn-block btn-lg" disabled={loading}>
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
          </form>
        ) : (
          <div className="empty-state" style={{ padding: '1.5rem 0' }}>
            <div className="icon">📧</div>
            <p style={{ color: 'var(--text-secondary)' }}>We've sent a password reset link to <strong>{email}</strong>. Please check your inbox and spam folder.</p>
          </div>
        )}

        <div className="auth-footer">
          <Link to="/login"><FiArrowLeft style={{ verticalAlign: 'middle' }} /> Back to Sign In</Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
